import React from 'react';

interface BilletMapProps {
  width?: string;
  height?: string;
  zoom?: number;
}

const BilletMap: React.FC<BilletMapProps> = ({
  width = '100%',
  height = '323px',
  zoom = 13,
}) => {
  const mapSrc =
    `https://www.google.com/maps/embed/v1/place?key=AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU&q=Billet%20Precision&zoom=${zoom}&maptype=roadmap`;

  return (
    <div style={{ width: width }}>
      <iframe
        title="Google Map"
        width="100%"
        height={height}
        frameBorder="0"
        scrolling="no"
        marginHeight={0}
        marginWidth={0}
        src={mapSrc}
        style={{ border: 0 }}
        allowFullScreen
      />
    </div>
  );
};

export default BilletMap;

